import { useEffect } from 'react';
import useTheme from './useTheme';
import { CSS_MODIFIERS } from '../../../constants/shared/theme/modifiers';
import { DARK_BLACK_FRIDAY, DEFAULT } from '../../../constants/shared/theme/names';
import { useService } from '../../../redux/reducer/service';
import { BLACK_FRIDAY, getIsAvailableEvent } from '../../../constants/events';
import { defaultStore } from '../../../translations';

export default function useThemeHandler() {
  const { serviceData } = useService();
  const { theme, set } = useTheme();

  useEffect(() => {
    if (!theme) return;

    Object.values(CSS_MODIFIERS)
      .filter(Boolean)
      .forEach((className) => document.body.classList.remove(className));

    CSS_MODIFIERS[theme] && document.body.classList.add(CSS_MODIFIERS[theme]);
  }, [theme]);

  useEffect(() => {
    if (theme !== DARK_BLACK_FRIDAY && !!serviceData && getIsAvailableEvent(defaultStore, BLACK_FRIDAY))
      set(DARK_BLACK_FRIDAY);
    else if (!getIsAvailableEvent(defaultStore, BLACK_FRIDAY) && !!serviceData && theme !== DEFAULT) set(DEFAULT);
  }, [theme, serviceData]);
}
